import { render, staticRenderFns } from "./InsAboutUs.vue?vue&type=template&id=3070674a&scoped=true"
import script from "./InsAboutUs.vue?vue&type=script&lang=ts"
export * from "./InsAboutUs.vue?vue&type=script&lang=ts"
import style0 from "./InsAboutUs.vue?vue&type=style&index=0&id=3070674a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3070674a",
  null
  
)

export default component.exports